import template from './kform-builder-edit-buttons.html';

const kformBuilderEditButtonsDirective = /* @ngInject */ () => ({
	scope: false,
	replace: true,
	template,
});

export default kformBuilderEditButtonsDirective;
